<script setup lang="ts">
import StackedLayout from '~/components/dato/StackedLayout.vue'

import { isNonNullAndDefined } from '~/utils/type-guards'

import type { EntityStackedLayoutFragment } from '~/graphql/generated'

type Props = EntityStackedLayoutFragment

defineProps<Props>()

function getComponentFromItem({ __typename }: Props['entities'][number]) {
  switch (__typename) {
    case 'CuratorCardRecord':
      return markRaw(
        defineAsyncComponent(() => import('~/components/dato/CuratorCard.vue')),
      )
    case 'PictureCardRecord':
      return markRaw(
        defineAsyncComponent(() => import('~/components/dato/PictureCard.vue')),
      )
  }
}
</script>

<template>
  <DatoSectionContainer>
    <StackedLayout v-if="isNonNullAndDefined(entities)" :items="entities">
      <template #default="{ item }">
        <component
          :is="getComponentFromItem(item)"
          v-bind="item"
          class="tw-h-full"
        />
      </template>
    </StackedLayout>
  </DatoSectionContainer>
</template>
